<template>
  <div class="warp">
    <el-descriptions class=" wars" title="1.产品信息"   border :column="3"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="产品中文名称">{{application.name}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品中文名称（拼音）：">{{application.namePinyin}}</el-descriptions-item>
      <el-descriptions-item   :span="1" label="产品英文名称">{{application.nameEnglish}}</el-descriptions-item>
      <el-descriptions-item   :span="3" label="产品类别">{{application.otherApplyType }}</el-descriptions-item>
      <el-descriptions-item   :span="3" v-if="application.otherCategoriesUrl != null" label="产品图片">
        <el-link :underline="false" type="primary" @click="handleDownload(application.otherCategoriesUrl,application.otherCategories)">{{application.otherCategories}}</el-link>
      </el-descriptions-item>
      <el-descriptions-item   :span="3" label="县级以上人民政府建议的地理标志产品保护范围">{{application.originRange}}</el-descriptions-item>
      <el-descriptions-item   :span="3" label="产品描述">{{application.description}}</el-descriptions-item>

      <!-- <el-descriptions-item   :span="3" v-if="application.fileNameCertificateUrl != null" label="产品名称作为商业用语或日常用语长久在先使用证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileNameCertificateUrl,application.fileNameCertificate)">{{application.fileNameCertificate}}</el-link>
      </el-descriptions-item> -->
    </el-descriptions>

    <el-descriptions class=" wars" title="2.产品情况说明"   border :column="3"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1" v-html="application.historical != null" label="产品历史渊源">{{application.historical}}</el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileNameHistoricalUrl != null" label="产品名称历史渊源证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileNameHistoricalUrl,application.fileNameHistorical)">{{application.fileNameHistorical}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.productSell != null" label="产品生产销售"><span v-html="application.productSell"></span></el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileProductSellUrl != null" label="产品生产销售及有关情况">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileProductSellUrl,application.fileProductSell)">{{application.fileProductSell}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.popularity != null" label="产品知名度"><span v-html="application.popularity"></span></el-descriptions-item>

      <el-descriptions-item  :span="1" v-if="application.fileProfileUrl != null" label="产品知名度证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileProfileUrl,application.fileProfile)">{{application.fileProfile}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="3.产品质量特色及保护要求"   border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <!-- <el-descriptions-item  :span="1"  label="质量要求"> <span v-html="application.quality"></span></el-descriptions-item> -->
      <!-- <el-descriptions-item  :span="1"  label="产品质量特色与产地自然因素和人文因素的关联性"> <span v-html="application.features"></span></el-descriptions-item> -->
      <!-- <el-descriptions-item  :span="1"  label="专用标志使用与检测机构要求"> <span v-html="application.specialMarks"></span></el-descriptions-item> -->
      <el-descriptions-item  :span="1"  v-if="application.sensoryCharacter != null" label="感官特色"> <span v-html="application.sensoryCharacter"></span></el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.pcIndexes != null" label="理化指标"> <span v-html="application.pcIndexes"></span></el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品保护要求">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileProductProtectionUrl,application.fileProductProtection)">{{application.fileProductProtection}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="4.商标及农产品信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="是否注册商标">{{application.isTrademark == 1 ? "是" : "否"}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标类型">{{application.trademarkType}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标注册证">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTrademarkCardUrl,application.fileTrademarkCard)">{{application.fileTrademarkCard}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.isTrademark == 1" label="商标注册证明、在先权利声明文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTrademarkUrl,application.fileTrademark)">{{application.fileTrademark}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  label="是否为农产品">{{application.isAgricultural == 1 ? "是" : "否"}}</el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.isAgricultural == 1" label="农产品证明文件">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileAgriculturalUrl,application.fileAgricultural)"> {{application.fileAgricultural}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="5.申报部门信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border"></el-descriptions>

    <el-descriptions class=" wars" title="申报机构"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="申报机构名称">{{application.applyName}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构联系人">{{application.applyContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构通信地址">{{application.applyAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构传真">{{application.applyFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构电话">{{application.applyPhone}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="申报机构电子邮箱">{{application.applyEmail}}</el-descriptions-item>
      <el-descriptions-item  :span="2"  label="当地县级以上人民政府关于成立申报机构或指定协会、企业作为申请人的文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileQualificationUrl,application.fileQualification)">{{application.fileQualification}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="产品所在地知识产权管理部门信息"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="单位名称">{{application.originName}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位联系人">{{application.originContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位通信地址">{{application.originAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位传真">{{application.originFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电话">{{application.originPhone }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电子邮箱">{{application.originEmail}}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="省级知识产权管理部门信息"  v-if="application.provinceName"  border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="单位名称">{{application.provinceName }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位联系人">{{application.provinceContacts}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位通信地址">{{application.provinceAddress}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位传真">{{application.provinceFax}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电话">{{application.provincePhone }}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="单位电子邮箱">{{application.provinceEmail }}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="6.申报材料"   border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  v-if="application.fileApplyUrl != null" label="地理标志产品保护申请书">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileApplyUrl,application.fileApply)">{{application.fileApply}}</el-link>
      </el-descriptions-item>

      <el-descriptions-item  :span="1"  v-if="application.fileAddressUrl != null" label="县级以上人民政府界定保护范围的建议的文件">
        <el-link :underline="false" type="primary"  @click="handleDownload(application.fileAddressUrl,application.fileAddress)">{{application.fileAddress}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1"  v-if="application.fileApplyProtectionUrl != null" label="县级以上人民政府申请保护文件">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileApplyProtectionUrl,application.fileApplyProtection)">{{application.fileApplyProtection}}</el-link>
      </el-descriptions-item>


      <el-descriptions-item  :span="1"  label="现行专有标准或技术规范">

        <el-table :data="application.standardDTOs" :cell-style="cellStyles" id="Table" :header-cell-style="headerStyles" border style="width: 100%">
          <el-table-column prop="fileStandard" label="文件名"></el-table-column>
          <el-table-column prop="standardType" label="标准规范类型"></el-table-column>
          <el-table-column prop="standardNum" label="标准规范编号"></el-table-column>
        </el-table>


      </el-descriptions-item>
      <el-descriptions-item  :span="1"  label="产品检测报告">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileTestReportUrl,application.fileTestReport)">{{application.fileTestReport}}</el-link>
      </el-descriptions-item>


      <!-- <el-descriptions-item  :span="1" v-if="application.fileAwardThatUrl" label="原系统产品获奖证明">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileAwardThatUrl,application.fileAwardThat)">{{application.fileAwardThat}}</el-link>
      </el-descriptions-item> -->
      <el-descriptions-item  :span="1"  label="其它证明材料">
        <el-link :underline="false" type="primary" @click="handleDownload(application.fileOtherUrl,application.fileOther)">{{application.fileOther}}</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions class=" wars" title="初审"   border :column="2"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.trialResult === 1 ? "通过" : (datas.trialResult === 2 ? "材料补正" : (datas.trialResult === 3 ? "未通过" : ""))}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  :label="datas.trialResult  == 1 ?  '省级知识产权管理部门提交产品保护申请初审意见函' : '初审意见通知书' ">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.trialFileUrl, datas.trialFileName)">{{datas.trialFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="形式审查"  v-if="datas.formalReviewResult !== null&&datas.formalReviewResult !==''" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.formalReviewResult == 1 ? "通过" : (datas.formalReviewResult == 2 ? "材料补正" : (datas.formalReviewResult ==3? "未通过" : ""))}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1" v-if="datas.formalReviewResult == 3 || datas.formalReviewResult == 2" label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.formalReviewFileUrl,datas.formalReviewFileName)">{{datas.formalReviewFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="形式审查(省确认形式审查补正是否通过)"  v-if="datas.formalReview_ProvinceFileName != null" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">未通过</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.formalReview_ProvinceFileUrl,datas.formalReview_ProvinceFileName)">{{datas.formalReview_ProvinceFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="技术审查"  v-if="datas.evaluationResult !== null&&datas.evaluationResult !== ''" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">{{datas.evaluationResult == 1 ? "通过" : (datas.evaluationResult == 2 ? "材料补正" : (datas.evaluationResult ==3? "未通过" : ""))}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.evaluationOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="会议纪要">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationMeetingFileUrl,datas.evaluationMeetingFileName)">{{datas.evaluationMeetingFileName}}</el-link>
      </el-descriptions-item>
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary" @click="handleDownload(datas.evaluationFileUrl,datas.evaluationFileName)">{{datas.evaluationFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


    <el-descriptions class=" wars" title="技术审查(省确认技术补正是否通过)"  v-if="datas.evaluation_ProvinceFileName != null" border :column="1"  label-class-name="my-label" content-class-name="my_content_border">
      <el-descriptions-item  :span="1"  label="审查结果">未通过</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="审查意见">{{datas.formalReviewOpinion}}</el-descriptions-item>
      <el-descriptions-item  :span="1"  label="意见通知书">
        <el-link :underline="false" type="primary"  @click="handleDownload(datas.evaluation_ProvinceFileUrl,datas.evaluation_ProvinceFileName)">{{datas.evaluation_ProvinceFileName}}</el-link>
      </el-descriptions-item>
    </el-descriptions>


  </div>
</template>

<script>

import {downloadFiles} from "../../../comm/utils/download";
import {downloadExamFile,recordinfo} from "../../api/home";


export default {
  name: "bzDetails",
  props:['application','datas'],
  data(){
    return{
      //application:{},
      //datas:{},
      headerStyles:
        {
          color:'#333',
          padding: '0.375rem',
          'border-right': '2px solid #ffffff',
          'text-align': 'center',
          background: '#eff5fA'
        },
      cellStyles: {'text-align': 'center'},
    }
  },
  mounted() {

  },

  methods:{
    //文件下载
    handleDownload(url,fileName){
      downloadExamFile({filePath:url, fileName:fileName}).then(response =>{
        downloadFiles(response,fileName)
      })
    },
  }
}
</script>

<style scoped lang="less">
.wars{
  margin-bottom: 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/landmark-user/views/applicationQuery/bzDetails.vue